import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconInfoSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconInfoSimple"><Path d="M12 9.5C12.4142 9.5 12.75 9.83579 12.75 10.25V18.5H14.25C14.6642 18.5 15 18.8358 15 19.25C15 19.6642 14.6642 20 14.25 20H9.75C9.33579 20 9 19.6642 9 19.25C9 18.8358 9.33579 18.5 9.75 18.5H11.25V11H9.75C9.33579 11 9 10.6642 9 10.25C9 9.83579 9.33579 9.5 9.75 9.5H12Z" fill="currentColor"/><Path d="M12 4C12.8284 4 13.5 4.67157 13.5 5.5C13.5 6.32843 12.8284 7 12 7C11.1716 7 10.5 6.32843 10.5 5.5C10.5 4.67157 11.1716 4 12 4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconInfoSimple;
